module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/630822338b3b498594075c8450abb52b.svg";